export const markerConstant: {
  size: number;
  image: string;
  countThreshold?: number;
}[] = [
  {
    size: 53,
    image: '/images/cluster-images/m1.png',
    countThreshold: 10,
  },
  {
    size: 56,
    image: '/images/cluster-images/m2.png',
    countThreshold: 25,
  },
  {
    size: 66,
    image: '/images/cluster-images/m3.png',
    countThreshold: 50,
  },
  {
    size: 78,
    image: '/images/cluster-images/m4.png',
    countThreshold: 100,
  },
  { size: 90, image: '/images/cluster-images/m5.png' },
];
